import React from 'react';
import Button from '../ui/Button';
import AppearanceMenu from './AppearanceMenu';
import DiscordLink from './DiscordLink';
import './TopBar.css';

/**
 * TopBar — slim sticky bar above the content area.
 *
 * Holds the mobile menu toggle, identity/balances, the Appearance picker, and
 * the quick actions that used to live in the old Header (Shop, Suggestions,
 * Profile, Logout). Primary navigation now lives in the Sidebar. Part of the
 * app-shell redesign (docs/frontend/DESIGN_REDESIGN.md §6.1).
 */
function TopBar({
  username,
  onLogout,
  onNavigate,
  isSubscribed,
  unclaimedBenefits,
  dateGenStatus,
  onToggleMobileSidebar,
  onCloseMobile
}) {
  // Navigate and also close the mobile drawer so it doesn't linger over content.
  const handleNavigate = (id) => {
    onNavigate(id);
    if (onCloseMobile) onCloseMobile();
  };

  return (
    <header className="app-topbar">
      <div className="topbar-left">
        <button
          className="topbar-menu-btn"
          onClick={onToggleMobileSidebar}
          aria-label="Open menu"
          title="Menu"
        >
          ☰
        </button>
        <span className="topbar-welcome">
          Welcome, <strong>{username}</strong>!
          {isSubscribed && (
            <span
              className="subscription-badge"
              title={
                unclaimedBenefits > 0
                  ? `${unclaimedBenefits} unclaimed weekly reward${unclaimedBenefits > 1 ? 's' : ''}!`
                  : 'Premium Subscriber'
              }
            >
              👑
              {unclaimedBenefits > 0 && <span className="subscription-unclaimed-dot" />}
            </span>
          )}
        </span>
      </div>

      <div className="topbar-right">
        {dateGenStatus && (
          <div className="header-date-gens">
            {dateGenStatus.unlimited ? (
              <span className="date-gen-label" title="Unlimited date generations">
                🎨 ∞
              </span>
            ) : (
              <>
                <span className="date-gen-label" title="Weekly date generations remaining">
                  🎨 {dateGenStatus.weekly_remaining}/{dateGenStatus.weekly_cap}
                </span>
                {dateGenStatus.bonus_remaining > 0 && (
                  <span className="date-gen-bonus" title="Bonus date generations (permanent)">
                    +{dateGenStatus.bonus_remaining}
                  </span>
                )}
              </>
            )}
          </div>
        )}

        <DiscordLink />

        <AppearanceMenu />

        <div className="topbar-actions">
          <Button variant="success" size="sm" onClick={() => handleNavigate('shop')} leftIcon="🛒" aria-label="Shop">
            Shop
          </Button>
          <Button variant="info" size="sm" onClick={() => handleNavigate('proposals')} leftIcon="💡" aria-label="Suggestions">
            Suggestions
          </Button>
          <Button variant="primary" size="sm" onClick={() => handleNavigate('profile')} leftIcon="👤" aria-label="Profile">
            Profile
          </Button>
          <Button variant="danger" size="sm" onClick={onLogout} leftIcon="🚪" aria-label="Logout">
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
}

export default TopBar;
